import { FirebaseServices } from "./config";
import { callFunction, callFunction2 } from "./helpers";
import { HelloWorldResponse } from "common247";

export async function helloWorldFunc(fb: FirebaseServices, name: string): Promise<string> {
  const result = await callFunction(fb, "helloWorldFunc", { name: name, timestamp: Date.now() });
  return JSON.stringify(result);
}

export async function helloWorldProfileBroken(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFunc", { name: name, timestamp: Date.now(), profile: { xxx: "xxx" } })) as HelloWorldResponse;
}

export async function helloWorldProfileNotBroken(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFunc", { name: name, timestamp: Date.now(), pr0file: { xxx: "xxx" } })) as HelloWorldResponse;
}

export async function helloWorldT(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction2(fb, "helloWorldFunc", "https://on247.net", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}

export async function helloWorldFuncAsync(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFuncAsync", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}

export async function helloWorldx(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFuncx", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}

export async function helloWorldCallable(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFuncCallable", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}

export async function helloWorldFuncSecure(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFuncSecure", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}

export async function helloWorldFuncSecureRule(fb: FirebaseServices, name: string): Promise<HelloWorldResponse> {
  return (await callFunction(fb, "helloWorldFuncSecureRule", { name: name, timestamp: Date.now() })) as HelloWorldResponse;
}
